const calorie = {
  getlist: 'specialdietcalorie/getlist',
  add: 'specialdietcalorie/add',
  update: 'specialdietcalorie/update',
  remove: 'specialdietcalorie/remove',
  get: 'diet/get',
  getall: 'specialdietcalorie/getall',
}
export default calorie
